<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>公告訊息</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
						<router-link to="/">
							<i class="fa fa-home"></i>
						</router-link>
					</li>
					<li>公告訊息</li>
				</ol>
			</div>
		</header>
		<section class="main">
			<header class="panel-heading">
				<h3 class="panel-title">最新消息</h3>
			</header>
			<section class="panel panel-default" style="margin-bottom: 0px;">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">查詢條件</h4>
				</header>
				<div id="searchArea" class="panel-collapse collapse">
					<div class="panel-body">
						<div class="row form-group">
							<div class="col-md-12 ">
								<div class="col-md-6">
									<label class="col-md-4">關鍵字查詢</label>
									<div class="col-md-8">
										<input type="text" v-model="hotKey" class="form-control"/>
									</div>
								</div>
								<div class="col-md-6"></div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-offset-4 col-md-4 ">
								<div class="col-md-offset-4 col-md-4">
									<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="panel-collapse">
				<div class="panel-body">
					<div class="row form-group" v-if="isAdmin('bulletin')">
						<div class="col-md-12 text-right form-inline">
							<a href="javascript:;" @click="gotoView('newsDetail',{isEdit:'Y'})" class="btn btn-danger">新增最新消息</a>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<table class="table table-no-more table-bordered table-striped mb-none" >
								<thead>
									<tr>
										<th class="text-center" width="5%" v-if="isAdmin('bulletin')">刪除</th>
										<th class="text-center" width="25%">公告日期</th>
										<th class="text-center" width="70%">標題</th>
										<!-- <th class="text-center" width="15%">發佈</th> -->
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in newsList" :key="index">
										<td v-if="isAdmin('bulletin')" class="text-center" data-title="">
											<a href="javascript:;" class="btn-link" @click="deleteNews(item.id)">刪除</a>
										</td>
										<td class="text-center" data-title="公告日期">{{customFormatter(item.newsBeginDate)}} ~ {{customFormatter(item.newsEndDate)}}</td>
										<td data-title="標題">
											<a href="javascript:;" class="btn-link" @click="gotoView('newsDetail', {isEdit:'N',id:item.id})">{{item.title}}</a>
										</td>
										<!-- <td class="text-center">[{{item.publishUnit}}]{{item.publishUser}}&emsp;{{item.crDateCht}}發佈</td> -->
										
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-md-12">
							<div class="text-center">
								<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
							</div>
						</div>
					</div>
				</div>
			</section>
		</section>
	</section>
	
</template>
<script>
export default {
	data(){
		return {
			page:1,
			pageSize:10,
			totalPage:0,
			newsList:[],
			hotKey:"",
		};
	},
	mounted(){
		this.updateGrid(1);
	},
	methods:{
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			let param = {
				page:this.page,
				pageSize:this.pageSize,
				model:{
					hotKey:this.hotKey
				}
			};
			const api = "/api/News/openNewsGrid";
			this.$axios.post(api, JSON.stringify(param)).then(resp =>{
				this.newsList = resp.data.data.rows;
				this.totalPage = resp.data.data.total
				this.page = resp.data.data.page;
				this.pageSize = resp.data.data.pageSize;
			});
		},
		deleteNews(id){
			let _this = this;
			bootbox.confirm("是否刪除此筆公告", function(result){
				if(result){
					const api = "/api/News/deleteNews/"+id;
					_this.$axios.delete(api).then(resp => {
						if(resp.data.status == "success"){
							_this.gridInit();
						}
					});
				}
			});
		}
	}
}
</script>